<template>
	<div class="footer_view">
		<div class="box">
			<div class="about_val">
				<p class="about_val_item">
					<span class="label_val">关于我们<span class="line_space">|</span></span>
					<span>广州市天河区启信教育培训中心有限公司为帮助国内高考人群适应高考改革后的高校招生计划和国家发展人才需求，启德教育特推出以新高考为核心的凌云计划系列服务，包括高中选科、专业定位、素质教育、多元升学规划（如：强基计划、综合评价、中外合作办学）、高考志愿指导报等，为体制内升学家庭提供安心、省心、放心的一站式服务。</span>
				</p>
				<p class="about_val_item">
					<span class="label_val">联系我们<span class="line_space">|</span></span>
					<span>
						<span class="conct_item">广州市天河区天河北路900号5楼
						</span>
						<span class="conct_item">
							400-837-3622
						</span>
					</span>
				</p>
				<p class="about_val_item" v-if="friendLink.length > 0">
					<span class="label_val">友情链接<span class="line_space">|</span></span>
					<span class="fl_item" v-for="(item, index) in friendLink" :key="index">
						<a :href="item.jumpUrl" target="_blank">{{ item.title }}</a>
					</span>
				</p>
			</div>
			<div class="about_QR">
				<div class="item">
					<img src="~assets/images/code.png" />
					<span>公众号</span>
				</div>
				<div class="item">
					<img src="~assets/images/taiyangma.png" />
					<span>小程序</span>
				</div>
			</div>
			<div class="footer">
				<div class="footerLeft">
					<div class="img">
						<img src="~assets/images/footer_left2.png" class="footer_left" alt="" />
					</div>
					<p>Copyright © yingzaigaokao.cn , All Rights Reserved.上海一启考教育科技有限公司<a
							href="https://beian.miit.gov.cn/" target="_blank"><img src="../assets/images/beian.png"
								alt="" />沪ICP备2025139427号-1 </a></p>
				</div>
				<div class="footerRight">
					<img src="~assets/images/footerTel.png" class="footer_right" alt="" />
					<p>400 837 3622<span>（咨询时间：9:00-21:00）</span></p>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: "Footers",
		props: {},
		data() {
			return {
				friendLink: []
			}
		},
		mounted() {
			this.$request({
				api: "plan",
				url: "Page/Info",
				method: "get",
				data: {
					pageInfoTypeId: 'aa47f1e50a67404782c9dbd08022191f',
				},
			}).then(res => {
				this.friendLink = res.data
			})
		}
	};
</script>

<style lang="scss" scoped>
	.footer_view {
		width: 100%;
		min-width: 1200px;
		background: #003B4F;
		display: flex;
		align-items: center;
		padding: 50px 0;
		flex-direction: column;

		.box {
			width: 1200px;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.about_val {
				width: 952px;
				font-family: SourceHanSansCN, SourceHanSansCN;
				font-weight: 400;
				font-size: 14px;
				color: #C7C7C7;
				line-height: 24px;
				text-align: left;
				font-style: normal;

				.about_val_item {
					margin-bottom: 26px;

					display: flex;

					.label_val {
						white-space: nowrap;
					}

					.line_space {
						padding: 0 8px;
					}

					.conct_item {
						display: flex;
						align-items: center;

						img {
							margin-right: 4px;
						}
					}

					.fl_item {
						display: inline-block;
						margin-right: 25px;

						>a {
							color: #C7C7C7;
						}
					}
				}
			}

			.about_QR {
				display: flex;
				justify-content: space-between;
				width: 180px;
				height: 100%;

				.item {
					width: 80px;

					img {
						display: block;
						width: 80px;
						height: 80px;
						margin-bottom: 24px;
					}

					&:last-child {
						img {
							display: block;
							width: 80px;
							height: 80px;
							border-radius: 40px;
						}
					}

					span {
						display: block;
						font-family: SourceHanSansCN, SourceHanSansCN;
						font-weight: 400;
						font-size: 14px;
						color: #C7C7C7;
						line-height: 21px;
						text-align: center;
						font-style: normal;
					}
				}
			}

			.footer {
				position: relative;
				width: 1200px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.footerLeft {
					display: flex;
					align-items: center;

					.img {
						width: 70px;
						border-right: 1px #C7C7C7 solid;
						margin-right: 10px;

						img {
							width: 62px;
							height: 62px;
						}
					}

					p {
						font-family: SourceHanSansCN, SourceHanSansCN;
						font-weight: 400;
						font-size: 14px;
						color: #C7C7C7;
						line-height: 26px;
						text-align: left;
						font-style: normal;

						a {
							display: flex;
							font-family: SourceHanSansCN, SourceHanSansCN;
							font-weight: 400;
							font-size: 14px;
							color: #C7C7C7;
							line-height: 21px;

							img {
								width: 20px;
								height: 20px;
								margin-right: 3px;
							}
						}
					}
				}

				.footerRight {
					display: flex;

					img {
						display: block;
						width: 24px;
						height: 25px;
						margin-right: 7px;
					}

					p {
						width: 150px;
						height: 26px;
						font-family: AvantGuardSW, AvantGuardSW;
						font-weight: bold;
						font-size: 22px;
						color: #C7C7C7;
						line-height: 26px;
						text-align: right;
						font-style: normal;

						span {
							display: block;
							width: 159px;
							height: 13px;
							font-family: SourceHanSansCN, SourceHanSansCN;
							font-weight: 400;
							font-size: 13px;
							color: #C7C7C7;
							line-height: 20px;
							text-align: left;
							font-style: normal;
						}
					}
				}
			}
		}
	}
</style>
